import { createReducer, on } from '@ngrx/store';
import { DocumentGenerationActions } from './actions';
import { initialState } from './state';

export const featureReducer = createReducer(
  initialState,
  on(
    DocumentGenerationActions.generateClauseList,
    (state, { payload, createDocumentImmediately }) => ({
      ...state,
      generatingClauseList: true,
      generateClauseListFailed: false,
      generatingDocument: !!createDocumentImmediately, // to show generating document spinner in case we're creating doc immediately
      creatingDocumentOperationsAreInProgress: !!createDocumentImmediately, // not to block create button in case we are just in step 2
    }),
  ),
  on(
    DocumentGenerationActions.generateClauseListSuccess,
    (state, { payload, generateClauseListResponse }) => ({
      ...state,
      lastGenerateClauseListPayload: payload,
      generatingClauseList: false,
      generateClauseListFailed: false,
      generateClauseListResponse,
    }),
  ),
  on(DocumentGenerationActions.generateClauseListFailure, (state, { payload }) => ({
    ...state,
    lastGenerateClauseListPayload: payload,
    generatingClauseList: false,
    generateClauseListFailed: true,
    generateClauseListResponse: null,
    creatingDocumentOperationsAreInProgress: false,
  })),
  on(DocumentGenerationActions.generateDocument, (state, {}) => ({
    ...state,
    generatingDocument: true,
    creatingDocumentOperationsAreInProgress: true,
    closeGenerateDocumentModal: false,
  })),
  on(
    DocumentGenerationActions.setGenerateDocumentResponse,
    (state, { generateDocumentResponse }) => ({
      ...state,
      generateDocumentResponse,
    }),
  ),
  on(DocumentGenerationActions.startAskingGenerateDocumentStatus, (state, {}) => ({
    ...state,
    askingGenerateDocumentStatus: true,
  })),
  on(DocumentGenerationActions.generateDocumentSuccess, (state, {}) => ({
    ...state,
    lastGenerateClauseListPayload: null,
    generateDocumentResponse: null,
    generatingDocument: false,
    generateClauseListFailed: false,
    generateClauseListResponse: null,
    askingGenerateDocumentStatus: false,
    creatingDocumentOperationsAreInProgress: false,
  })),
  on(DocumentGenerationActions.generateDocumentFailure, (state) => ({
    ...state,
    lastGenerateClauseListPayload: null,
    generateDocumentResponse: null,
    generateClauseListResponse: null,
    generatingDocument: false,
    generateClauseListFailed: false,
    askingGenerateDocumentStatus: false,
    creatingDocumentOperationsAreInProgress: false,
  })),
  on(DocumentGenerationActions.generateDocumentCancelled, (state, {}) => ({
    ...state,
    lastGenerateClauseListPayload: null,
    generateClauseListResponse: null,
    generateClauseListFailed: false,
    closeGenerateDocumentModal: true,
    creatingDocumentOperationsAreInProgress: false,
  })),
  on(DocumentGenerationActions.closeGenerateDocumentModal, (state, {}) => ({
    ...state,
    lastGenerateClauseListPayload: null,
    generateClauseListResponse: null,
    generateClauseListFailed: false,
    closeGenerateDocumentModal: true,
  })),
  on(DocumentGenerationActions.resetGenerateDocumentResults, (state, {}) => ({
    ...state,
    lastGenerateClauseListPayload: null,
    generatingDocument: false,
    askingGenerateDocumentStatus: false,
    generateClauseListFailed: false,
    generateClauseListResponse: null,
    generateDocumentResponse: null,
    closeGenerateDocumentModal: false,
  })),
  on(DocumentGenerationActions.clearGenerateDocumentCancelled, (state, {}) => ({
    ...state,
    closeGenerateDocumentModal: false,
  })),
);
